import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

/** A hero's name can't match the given regular expression */
export function regExValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = nameRe.test(control.value);
    return !valid ? { regExValidator: { value: control.value } } : null;
  };
}

@Directive({
  selector: '[regExValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: RegExValidatorDirective, multi: true }]
})
export class RegExValidatorDirective implements Validator {
  @Input('regExValidator') regEx = '';

  validate(control: AbstractControl): ValidationErrors | null {
    return this.regEx ? regExValidator(new RegExp(this.regEx, 'i'))(control)
      : null;
  }
}
